import { Cta } from "@/components/Cta";
import { PageHero } from "@/components/PageHero";
import { useSeo } from "@/lib/seo";

export default function NotFound() {
  useSeo("/404");
  return (
    <PageHero
      eyebrow="404"
      title="Page not found"
      description="The page you were looking for doesn't exist or has moved."
    >
      <Cta to="/">Back to home</Cta>
      <Cta to="/platform" variant="ghost">
        Explore the platform
      </Cta>
    </PageHero>
  );
}
